import { useEffect, useState } from "react";
import api from "../../lib/api";
import PageHeader from "../../components/PageHeader";
import { StatCard } from "../../components/StatCard";
import { ConnectedUsersPanel } from "../../components/ConnectedUsersPanel";
import { LayoutDashboard, Building2, Users, UserCog, CheckCircle2, PauseCircle } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then(({ data }) => setStats(data)).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <PageHeader
        title="Dashboard Piattaforma"
        subtitle="Panoramica globale multi-tenant di tutti gli studi registrati su PatroGestPro."
        icon={LayoutDashboard}
      />
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <StatCard label="Studi Totali" value={stats?.studi_totali ?? "—"} icon={Building2} accent="amber" testId="stat-studi-totali" />
        <StatCard label="Studi Attivi" value={stats?.studi_attivi ?? "—"} icon={CheckCircle2} accent="green" testId="stat-studi-attivi" />
        <StatCard label="Studi Sospesi" value={stats?.studi_sospesi ?? "—"} icon={PauseCircle} accent="red" testId="stat-studi-sospesi" />
        <StatCard label="Titolari" value={stats?.titolari ?? "—"} icon={UserCog} accent="cyan" testId="stat-titolari" />
        <StatCard label="Operatori" value={stats?.operatori ?? "—"} icon={Users} accent="slate" testId="stat-operatori" />
        <StatCard label="Clienti" value={stats?.clienti ?? "—"} icon={Users} accent="amber" testId="stat-clienti" />
      </div>
      <ConnectedUsersPanel />
    </div>
  );
}
